//送信エリア
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withCookies } from 'react-cookie';
import { TextField, Typography, Grid, FormControlLabel, Checkbox, FormControl, FormGroup, Select, MenuItem } from '@material-ui/core';

const styles = () => ({
    paper: {
        // margin: '5px 5px 5px 50px',
        margin: '0 auto',
        width: 1150
    },
    textField: {
        display: 'flex',
        boxShadow: '0px 2.5px 1px -1px rgba(0,0,0,0.2)',
        fontSize: '18px',
    },
    lengthTypography: {
        fontSize: '22px',
        display: 'flex',
        textAlign: 'right',
        justifyContent:'right',
    },
    errString:{
        color: '#ff0000',
        fontSize: '20px'
    },
    titleLabel:{
        ontSize: '20px',
        marginTop: '30px'
    },
    titleField: {
        display: 'flex',
        boxShadow: '0px 2.5px 1px -1px rgba(0,0,0,0.2)',
        fontSize: '18px',
        marginTop: '10px',
        marginBottom: '20px',
        width: 750
    },
    categoryField: {
        display: 'flex',
        boxShadow: '0px 2.5px 1px -1px rgba(0,0,0,0.2)',
        fontSize: '18px',
        marginTop: '10px',
        width: 300
    },
    selectKubunArea: {
        marginTop:'10px',
    },
    deletionFlgList:{
        borderBottom: 'solid 2px #FFF',
        height:'40px',
    },
    keyword:{
        left: '30px',
        //marginLeft: '1px',
        width: 400
    },
    categoryChatList: {
        width: '300px',
        marginBottom: '20px'
    },
    inputKeyword:{
        justifyContent:'center',
        alignItems: 'center',
        margin: '25px 10px 10px 0px',
    }
});

//メッセージの最大文字数
const maxString = 5000;

const MsgArea = withCookies((props) => {
    const { classes, data, cookies } = props;
    const chatNameObj = cookies.get('COMMON_NAME_OBJ');
    const kubunName = chatNameObj !== undefined ? chatNameObj.KUBUN_NAME : 'チャットカテゴリ';

    return (
        <React.Fragment>
            <div elevation={3} className={classes.paper} >
                <Typography className={classes.titleLabel}>{'配信タイトル：'}</Typography>
                <TextField
                    className={classes.titleField}
                    name="Text"
                    margin="normal"
                    variant="outlined"
                    value={data.chatTitle}
                    InputProps={{
                        readOnly: true,
                    }}
                />
                <Grid container direction="column" >
                    <div style={{ height: '100%' }}>
                        <div className={classes.root}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data.requestFlg}
                                        InputProps={{
                                            readOnly: true,
                                        }}
                                    />
                                }
                                label={<Typography variant="body2">依頼メッセージを送信する</Typography>}
                            />
                        </div>
                    </div>
                    { data.requestFlg && (
                        <FormGroup className={classes.selectKubunArea} row>
                            <Typography variant="body1" className={classes.inputKeyword}>
                                {`${kubunName}：`}
                            </Typography>
                            <TextField
                                className={classes.categoryField}
                                name="Text"
                                margin="normal"
                                variant="outlined"
                                value={data.chatCategory}
                                InputProps={{
                                    readOnly: true,
                                }}
                            />
                        </FormGroup>
                    )}
                </Grid>
                <TextField
                    className={classes.textField}
                    multiline
                    maxRows={13}
                    minRows={13}
                    InputProps={{
                        readOnly: true,
                    }}
                    name="Text"
                    margin="normal"
                    variant="outlined"
                    value={data.message}
                />
                <Typography className={classes.lengthTypography}>{data.message.length + '/' + maxString}</Typography>
            </div>
        </React.Fragment>
    );
});

export default withStyles(styles)(MsgArea);